import React from 'react';

import SwitchSetting from './SwitchSetting';
import SwitchSettingButton from './SwitchSettingButton';
import {useSwitchSetting} from './useSwitchSetting';

export const createSwitchSetting = ({settingType, selector, onNavigate}) => {
    const useSettingHook = () => useSwitchSetting(settingType, selector);

    const SettingComponent = () => <SwitchSetting settingType={settingType} useSettingHook={useSettingHook} />;

    const ButtonComponent = (props) => (
        <SwitchSettingButton {...props} useSettingHook={useSettingHook} onNavigate={onNavigate} />
    );

    return {
        useSettingHook,
        SettingComponent,
        ButtonComponent,
    };
};
